import { Component, ViewEncapsulation, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
    selector: 'portal-session-timeout-dialog',
    template: `
        <div class="relative flex h-full w-full flex-col">
            <div class="flex flex-auto flex-col items-center p-8 pb-6 sm:flex-row sm:items-start sm:pb-8">
                <div class="mt-4 flex flex-col items-center space-y-1 text-center sm:mt-0 sm:items-start sm:pr-8 sm:text-left">
                    <div class="text-xl font-medium leading-6" [innerHTML]="data.title"></div>
                    @if (data.message) {
                        <div class="text-secondary" [innerHTML]="data.message"></div>
                    }
                </div>
            </div>
            <div class="flex items-center justify-center space-x-3 bg-gray-50 px-6 py-4 dark:bg-black dark:bg-opacity-10 sm:justify-end">
                <button mat-stroked-button [matDialogClose]="'cancelled'">{{ data.cancelLabel }}</button>
                <button mat-flat-button [color]="'primary'" [matDialogClose]="'confirmed'">{{ data.confirmLabel }}</button>
            </div>
        </div>
    `,
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [MatButtonModule, MatDialogModule],
})
export class SessionTimeoutDialogComponent {
    data: { title: string; message?: string; confirmLabel: string; cancelLabel: string } = inject(MAT_DIALOG_DATA);
}
